import styled from 'styled-components'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'

interface Props {
  columns: TableColumn[]
  children: JSX.Element[]
  className?: string
}

export default function SimpleTable({ columns, children, className }: Props): JSX.Element {
  const hasWidthSettings = () => {
    return columns.length > 0 ? columns[0].width !== undefined : false
  }

  return (
    <TableContainer className={className}>
      <StyledTable aria-labelledby="tableTitle" size="small">
        {hasWidthSettings() && (
          <colgroup>
            {columns.map((column: TableColumn) => (
              <col key={`tablecol-${column.id}`} style={{ width: `${column.width}%` }} />
            ))}
          </colgroup>
        )}
        {columns.length > 0 && (
          <StyledTableHead>
            <TableRow>
              {columns.map((column: TableColumn) => (
                <TableCell key={`tablecell-${column.id}`} align={column.numeric ? 'right' : 'left'}>
                  {column.label}
                  {column.description && <Description>{column.description}</Description>}
                </TableCell>
              ))}
            </TableRow>
          </StyledTableHead>
        )}
        <TableBody>{children}</TableBody>
      </StyledTable>
    </TableContainer>
  )
}

const StyledTableHead = styled(TableHead)`
  background-color: ${(props) => props.theme.palette.primary.dark};
  height: 40px;

  & th,
  span {
    color: ${(props) => props.theme.customPalette.light};
    font-size: 13px;
    line-height: 15px;
    text-transform: uppercase;
  }
  & span:hover {
    color: ${(props) => props.theme.customPalette.light};
    opacity: 0.8;
  }
  & svg {
    color: #fff;
  }
`

const StyledTable = styled(Table)`
  border: 1px solid;
  border-color: ${(props) => props.theme.customPalette.lightGray};
`

const Description = styled.div`
  display: inline-block;
  margin-left: 10px;
  font-size: 0.75em;
`
